
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Pager } from '@/models/dynamiclist';

@Component({})
export default class PagerComponent extends Vue {

    @Getter('pager')
    public pager!: Pager;

    @Action('changePage')
    private changePage!: (page: number) => void;

    public goToPage(page: number) {
        this.$store.dispatch('changePage', page);
    }

    public firstPage(): void {
        this.goToPage(0);
    }

    public prevPage(): void {
        this.goToPage(this.pager.page - 1);
    }

    public nextPage(): void {
        this.goToPage(this.pager.page + 1);
    }

    public lastPage(): void {
        this.goToPage(this.pager.totalPages - 1);
    }
}
